import React, { Fragment } from "react";
import ServiceCard from "../components/card/ServiceCard";
import servicesData from "../data/services/servicesContentItems.json";
import MetaTags from "react-meta-tags";
import Loading from "../blocks/loading/Loading";
import Header from "../blocks/header/Header";
import Footer from "../blocks/footer/Footer";
import PageTitleReservation from "../blocks/page-title/PageTitleReservation";
import { Toaster } from "react-hot-toast";
import BookingLink from "../components/button/BookingLink";

const ReservationPage = () => {
  // Mapper les données pour générer les cartes de service
  const serviceCards = servicesData
    .filter((service) => service.soins.products.length > 0)
    .map((service) => {
      return (
        <ServiceCard
          key={service.id}
          title={service.title}
          soins={service.soins}
        />
      );
    });

  return (
    <Fragment>
      <Toaster />
      <MetaTags>
        <meta charSet="UTF-8" />
        <title>
          Réservation | Julie Bengueddach - Esthéticienne professionelle
        </title>

        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta
          name="google-site-verification"
          content="-sL3qrR8XuJRi2vK6gvyph3PkILJ22ISSOo35kEVpXo"
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1,user-scalable=no"
        />
        <meta
          name="description"
          content="Prenez rendez-vous avec Julie Bengueddach, esthéticienne professionnelle située à Igny, pour des soins visages, corps, épilation, microblading, microshading, maquillage et manucure/beauté des pieds."
        />
        <meta
          name="keywords"
          content="esthéticienne, Igny, soins visages, soins corps, épilation, microblading, microshading, maquillage, manucure, beauté des pieds, prendre rendez-vous, réservation"
        />
        <meta name="robots" content="index, follow, noodp" />
        <meta name="googlebot" content="index, follow" />
        <meta name="google" content="notranslate" />
        <meta name="format-detection" content="telephone=no" />
      </MetaTags>

      <Loading />

      <Header logoColor="light" />

      <main id="main" className="site-main">
        <div>
          <PageTitleReservation />

          <div id="description" className="block p-top-xl">
            <div className="booking-intro description">
              <p>
                Julie vous accueille dans un cadre chaleureux et relaxant pour
                vous offrir des moments de détente et de bien-être.
              </p>
              <p>
                La prise de rendez-vous s’effectue désormais sur Planity, où
                vous retrouverez les prestations et les créneaux disponibles.
              </p>
              <BookingLink
                className="btn btn-lg btn-outline-secondary"
                showExternalIcon
              >
                Prendre rendez-vous sur Planity
              </BookingLink>
              <p className="booking-external-note">
                Planity s’ouvrira dans un nouvel onglet.
              </p>
            </div>
          </div>

          <div className="wrapper">
            <section
              className="booking-services spacer p-top-lg"
              aria-labelledby="booking-services-title"
            >
              <div className="title text-center">
                <h2 id="booking-services-title" className="hr">
                  Nos prestations
                </h2>
              </div>
              <div className="service-card-container">{serviceCards}</div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </Fragment>
  );
};

export default ReservationPage;
